import http from "infra/http";
import { useQuery } from "react-query";
import { PastaItem, UsePastasParams } from "../documentos/typings";

function usePastasUnidade({ pastaPaiId, unidadeId }: UsePastasParams) {
  return useQuery(
    `/v1/unidade/${unidadeId}/documento/pastas?documentoPaiId=${pastaPaiId}`,
    async () => {
      const { data } = await http.get<PastaItem[]>(
        `/v1/unidade/${unidadeId}/documento/pastas`,
        {
          params: {
            documentoPaiId: pastaPaiId,
          },
        }
      );

      return data;
    }
  );
}

export default usePastasUnidade;
